"use client";
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './styles.css'

const Footer = () => {
    return (
        <footer className="footer d-flex justify-content-center align-items-center w-100">
            <p className="m-2">By @marcojalenyu & @danemarcuschan. Go to <a className='fw-bold' href='https://linktr.ee/csnotes'>csnotes</a> for notes.</p>
        </footer>
    );
}

export default Footer;